import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapEditControlComponent } from './field-editor-map-edit-control.component';
import {
  DxButtonGroupModule,
  DxButtonModule,
  DxFormModule,
  DxLoadIndicatorModule, DxLoadPanelModule,
  DxPopoverModule, DxPopupModule, DxSpeedDialActionModule,
  DxToolbarModule, DxTextAreaModule,
} from 'devextreme-angular';
import { IconModule } from '@visurel/iconify-angular';
import { UserDomainsChooserModule } from '../../user-domains/user-domains-chooser/user-domains-chooser.module';
import { FieldEditorMapCropListModule } from '../field-editor-map-crop-list/field-editor-map-crop-list.module';
import { FieldCropsPopupModule } from '../../field-crops/field-crops-popup/field-crops-popup.module';


@NgModule({
  declarations: [FieldEditorMapEditControlComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    DxButtonGroupModule,
    IconModule,
    DxButtonModule,
    DxPopoverModule,
    DxFormModule,
    UserDomainsChooserModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    FieldEditorMapCropListModule,
    DxPopupModule,
    DxSpeedDialActionModule, DxTextAreaModule, FieldCropsPopupModule,
  ],
  exports: [FieldEditorMapEditControlComponent]
})
export class FieldEditorMapEditControlModule {
}
